<template>
  <a-row type="flex" justify="space-between">
    <a-col class="table-controls-margin">
      <a-form layout="inline" ref="formRef" :model="formState">
        <a-form-item>
          <a-tooltip title="Busca por ticket ID, nombre del contacto, teléfono, nombre de usuario o identificador en WhatsApp">
            <a-input
              v-model:value="formState.search"
              placeholder="Buscar"
              style="width: 150px"
            >
              <template #prefix>
                <search-outlined />
              </template>
            </a-input>
          </a-tooltip>
        </a-form-item>

        <a-form-item>
          <plan-range-picker
            v-model="formState.dateRange"
            @update:modelValue="changeDateRange" 
            format="DD/MM/YYYY HH:mm"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :show-time="{ format: 'HH:mm' }"
            :style="{ width: '320px' }"
          />
        </a-form-item>

        <entity-picker
          :value="formState.entity"
          @update:value="changeEntity"
          :blockAllEntities="blockAllEntities"
          style="width: 160px"
          withOutEntities
        />

        <campaign-picker
          :value="formState.portfolio"
          @update:value="changePortfolio"
          :entity="formState.entity"
          style="width: 160px"
          :showAll="true"
          defaultBehavior
        />

        <!-- <a-form-item>
          <a-select
:getPopupContainer="triggerNode => triggerNode.parentNode"            v-model:value="formState.channel"
            :options="channelOptions"
            style="width: 190px"
          />
        </a-form-item> -->
      </a-form>
    </a-col>

    <a-col class="table-controls-margin">
      <div class="refresh-wrapper">
        <a-button style="padding: 0" type="link" @click="handleUpdateData">
          Actualizar datos recientes
        </a-button>
      </div>
      <a-tooltip>
        <template #title> Configura las columnas a mostrar </template>
        <a-button @click="handleOpenColumnFilterDrawer" style="margin-right: 8px">
          Columnas
          <table-outlined />
        </a-button>
      </a-tooltip>

      <a-button @click="handleOpenAdvancedFiltersDrawer" style="margin-right: 8px">
        Filtros
        <a-badge :dot="advancedFilters">
          <FilterOutlined style="margin-left: 4px" />
        </a-badge>
        <!-- <filter-outlined /> -->
      </a-button>

      <a-tooltip arrow-point-at-center placement="topRight">
        <template #title>
          <span v-if="isGlobalDownloading">Tiene una descarga pendiente</span>
          <span v-else>
            {{
              disabledDownload
                ? "No se puede realizar la descarga debido a la alta carga que conlleva la consulta."
                : "Tus tickets se descargarán de acuerdo a los filtros seleccionados."
            }}
          </span>
        </template>

        <a-button
          @click="handleDownload"
          :loading="downloading"
          :disabled="disabledDownload || isGlobalDownloading"
        >
          Descargar
          <download-outlined />
        </a-button>
      </a-tooltip>
    </a-col>
  </a-row>

  <div v-if="selectedRows.length !== 0" class="multiselect-row">
    <div class="counter">
      <span>
        <template v-if="selectedRows.length === 1">
          Se ha seleccionado <strong>1 ticket</strong> de esta página.
        </template>
        <template v-else>
          Se han seleccionado
          <strong
            >{{
              selectedAllDataFilters ? data?.count_selected : selectedRows.length
            }}
            tickets</strong
          >.
        </template>
        <template v-if="selectedRows.length < data?.total_ticket_transfer">
          <a-button type="link" style="padding-left: 0" @click="handleSelectedAll()">
            Seleccionar los {{ data?.total_ticket_transfer }} tickets encontrados según tus filtros
          </a-button>
        </template>
      </span>
    </div>

    <div class="actions">
      <a-tooltip
        placement="bottom"
        :title="
          uniquePortfolios.length !== 1
            ? 'Los tickets seleccionados deben pertenecer a una sola campaña para poder ser transferidos. '
            : null
        "
      >
        <a-dropdown
          placement="bottomRight"
          :trigger="['click']"
          :overlayStyle="{ width: '220px' }"
          @click="handleTransferClick"
        >
          <a-button :disabled="uniquePortfolios.length !== 1" type="link" @click.prevent>
            Transferir <SwapOutlined />
          </a-button>

          <template #overlay>
            <a-menu @click="handleDropdownClick">
              <a-menu-item key="queues-users"> Transferir por cola y usuario </a-menu-item>
              <a-menu-item
                key="users"
                :disabled="uniqueQueues.length !== 1 || uniqueQueues.includes(null)"
              >
                <a-tooltip
                  :title="
                    uniqueQueues.length !== 1
                      ? 'Los tickets seleccionados deben pertenecer a una misma cola para poder ser transferidos a un usuario.'
                      : null
                  "
                  placement="left"
                >
                  Transferir a un usuario
                </a-tooltip>
              </a-menu-item>

              <a-menu-item key="queues"> Transferir a cola </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <!-- <a-button
          type="link"
          @click="openQueueTransferModal = true"
          :disabled="uniquePortfolios.length !== 1"
        >
          Transferir <SwapOutlined />
        </a-button> -->
      </a-tooltip>

      <a-divider type="vertical" class="divider" />

      <a-dropdown placement="bottomRight">
        <a-button type="link" @click.prevent> Etiquetar <TagOutlined /> </a-button>

        <template #overlay>
          <a-menu v-if="tagsData.length !== 0" @click="handleTagDropdownClick">
            <a-menu-item v-for="tag in tagsData" :key="tag.id" :disabled="tag.is_permanent">
              <div class="tag-dropdown-menu">
                <div class="tag-color" :style="{ backgroundColor: `#${tag.color}` }" />
                <span>
                  {{ tag.name }}
                </span>
              </div>
            </a-menu-item>
          </a-menu>

          <a-menu v-else>
            <a-menu-item disabled> No hay etiquetas </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

      <a-divider type="vertical" class="divider" />

      <a-button type="link" @click="handleResolve"> Resolver <CheckOutlined /> </a-button>
    </div>

    <QueueUserTransferModal
      v-if="openQueueUserTransferModal"
      v-model:open="openQueueUserTransferModal"
      :origin="2"
      :queues="transferData.queues"
      :ticketIdList="selectedRowsList.map((row) => row.id)"
      :agentsList="[...new Set(selectedRowsList.map((row) => row.user_assigned))]"
      :portfolio="portfolioItemsSelectedTransfer"
      :entity="portfolioItemsSelectedTransfer?.entity"
      is-async
      @update="
        updateSelectedTableRowKeys([]);
        openQueueUserTransferModal = false;
        // handleUpdateData();
      "
    />

    <QueueTransferModal
      v-if="openQueueTransferModal"
      v-model:open="openQueueTransferModal"
      :origin="2"
      :queues="transferData.queues"
      :ticketIdList="selectedRowsList.map((row) => row.id)"
      :portfolio="portfolioItemsSelectedTransfer"
      :entity="portfolioItemsSelectedTransfer?.entity"
      is-async
      @update="
        updateSelectedTableRowKeys([]);
        openQueueTransferModal = false;
        // handleUpdateData();
      "
    />

    <UserTransferModal
      v-if="openUserTransferModal"
      v-model:open="openUserTransferModal"
      :origin="2"
      :users="transferData.agents"
      :queue="uniqueQueues.at(0)"
      :ticketIdList="selectedRowsList.map((row) => row.id)"
      :agentsList="[...new Set(selectedRowsList.map((row) => row.user_assigned))]"
      is-async
      @update="
        updateSelectedTableRowKeys([]);
        openUserTransferModal = false;
        handleUpdateData();
      "
    />
  </div>

  <section v-if="wrongInputsMessage.show">{{ wrongInputsMessage.content }}</section>
</template>

<script lang="ts">
import { computed, onMounted, ref, inject, reactive, watch, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal, message } from "ant-design-vue";
import _ from "lodash";
import {
  QuestionCircleOutlined,
  SearchOutlined,
  FilterOutlined,
  DownloadOutlined,
  TagOutlined,
  CheckOutlined,
  SwapOutlined,
  TableOutlined,
} from "@ant-design/icons-vue";

import { disabledDateFuture, dateToString } from "@/app/shared/utils/dates";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";
import { usePlanSearchRange } from "@/app/shared/composables/usePlanDateRange";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import QueueUserTransferModal from "@/app/ticketsManager/components/modals/transfer/QueueUserTransferModal.vue";
import QueueTransferModal from "@/app/ticketsManager/components/modals/transfer/QueueTransferModal.vue";
import UserTransferModal from "@/app/ticketsManager/components/modals/transfer/UserTransferModal.vue";

import {
  fetchTicketsIdsWithBasicFilters,
  fetchTicketsIdsWithAdvancedFilters,
} from "@/app/ticketsManager/services";
import dayjs from "dayjs";

import PlanRangePicker from "@/app/shared/components/pickers/PlanRangePicker.vue";
import { PlanEspecial } from "@/app/common/types";

export default {
  components: {
    EntityPicker,
    CampaignPicker,
    PlanRangePicker,
    SearchOutlined,
    FilterOutlined,
    DownloadOutlined,
    TagOutlined,
    CheckOutlined,
    SwapOutlined,
    TableOutlined,
    QueueUserTransferModal,
    QueueTransferModal,
    UserTransferModal,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectedRows: {
      type: Array,
      required: true,
    },
    downloading: {
      type: Boolean,
      default: false,
    },
    rangeDates: {
      type: Object,
      default: { value: null, format_time: null },
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { isGlobalDownloading } = useGlobalDownloadState();
    const selectedAll = inject("selectedAll");
    const selectedAllDataFilters = inject("selectedAllDataFilters");

    const channelOptions = computed(() => store.getters["getTicketManagerChannels"]);
    const userData = computed(() => store.getters["getDataUser"]);
    const plan = computed(() => userData.value?.change_custom_plan?.plan);
    const isUnlimited = computed(() => plan.value === PlanEspecial);

    // Limite de fechas segun el plan del cliente
    const { rangeLimit, typeRange, rangeLimitText } = usePlanSearchRange(15);

    const {
      validateDates,
    } = useDateRangeLimit(rangeLimit, typeRange, isUnlimited);

    const currentDay = dateToString(new Date()).substring(0, 10);
    const wrongInputsMessage = reactive({ show: false, content: "" });

    const formRef = ref(null);
    const formState = reactive({
      entity: "",
      portfolio: null,
      channel: "",
      search: "",
      dateRange: [`${currentDay} 00:00:00`, `${currentDay} 23:59:59`],
    });

    const blockAllEntities = ref(false);
    // const disabledDownload = computed(() => formState.entity === "" && formState.channel === "");

    // Get tags and ticketManagerChannels data
    onMounted(() => {
      store.dispatch("fetchTags");
      store.dispatch("fetchTicketManagerAllChannels");

      const { entity, portfolio, channel, search, dateRange } = formState;

      const fields = {
        entity: entity ?? "",
        portfolio,
        channel,
        search,
        startDate: dateRange?.[0] ? dateToString(dateRange?.[0]) : null,
        endDate: dateRange?.[1] ? dateToString(dateRange?.[1]) : null,
      };

      emit("form-fields-completed", fields);
      changeTableControls(true);
    });

    const changeTableControls = (resetAdvancedFilters) => {
      const { entity, portfolio, channel, search, dateRange } = formState;

      console.log("changeTableControls called with formState:", formState);
      if (!dateRange?.[0] || !dateRange?.[1]) {
        wrongInputsMessage.show = true;
        wrongInputsMessage.content = "Ingrese un rango de fechas válido";
        emit("show-table", false);
        return;
      }

      // Convierte el string a Dayjs antes de pasarlo a disabledDateRage
      const startDateDayjs = dateRange?.[0] ? dayjs(dateRange[0]) : null;
      const endDateDayjs = dateRange?.[1] ? dayjs(dateRange[1]) : null;
      const validationDates = validateDates(startDateDayjs, endDateDayjs);
      
      console.log("validationDates", validationDates);
      if (!validationDates) {
        wrongInputsMessage.show = true;
        wrongInputsMessage.content = `Ingrese un rango de fechas de hasta ${rangeLimit.value} ${typeRange.value == 'months' ? 'meses' : 'días'}`;
        emit("show-table", false);
        return;
      }

      // if (!(entity > 0 && !portfolio)) {
      const fields = {
        entity: entity ?? "",
        portfolio,
        channel,
        search,
        startDate: dateRange?.[0] ? dateToString(dateRange?.[0]) : null,
        endDate: dateRange?.[1] ? dateToString(dateRange?.[1]) : null,
      };

      emit("form-fields-completed", { basicFilters: fields, resetAdvancedFilters });
      // }

      if (formState.entity === "" || formState.entity === 0) {
        wrongInputsMessage.show = false;
        emit("show-table", true);
      }

      if (formState.entity && !formState.portfolio) {
        // wrongInputsMessage.show = true;
        // wrongInputsMessage.content =
        //   "Debe seleccionar una campaña para poder mostrar los tickets";
        // blockAllEntities.value = false;
        // emit("show-table", false);

        wrongInputsMessage.show = false;
        emit("show-table", true);
      }

      if (entity !== "" && portfolio) {
        wrongInputsMessage.show = false;
        emit("show-table", true);
      }
    };

    watch(
      () => formState.search,
      _.debounce(() => {
        changeTableControls(false);
      }, 600)
    );

    const selectedTableRowKeys = inject("selectedTableRowKeys");
    const updateSelectedTableRowKeys = inject("updateSelectedTableRowKeys");
    const selectedRowsLastChannel = inject("selectedRowsLastChannel");
    const selectedRowsList = inject("selectedRowsList");

    const openQueueTransferModal = ref(false);
    const openUserTransferModal = ref(false);
    const openQueueUserTransferModal = ref(false);

    const transferData = computed(() => store.getters["getTransferData"]);
    const uniquePortfolios = computed(() => [
      ...new Set(selectedRowsList.value.map((item) => item.portfolio)),
    ]);
    const uniqueQueues = computed(() => [
      ...new Set(selectedRowsList.value.map((item) => item.queue)),
    ]);
    const portfolioItemsSelectedTransfer = computed(() => {
      const item = selectedRowsList.value?.[0];
      return { id: item.portfolio_id, name: item.portfolio, entity: item.entity };
    });

    // watch(uniquePortfolios, (newUniquePortfolios, oldUniquePortfolios) => {
    //   if (newUniquePortfolios.length !== 1) return;
    //   if (isEqual(newUniquePortfolios, oldUniquePortfolios)) return;

    //   store.dispatch("fetchTransferData", selectedRowsList.value.at(0)?.id);
    // });
    const handleTransferClick = async () => {
      const ticketId = selectedRowsList.value.at(0)?.id;

      await store.dispatch("fetchTransferData", { ticket: ticketId, origin: 2 });
    };

    const handleDropdownClick = async ({ key } = {}) => {
      if (key === "users") openUserTransferModal.value = true;
      if (key === "queues") openQueueTransferModal.value = true;
      if (key === "queues-users") openQueueUserTransferModal.value = true;
    };

    const tagsData = computed(() => store.getters["getTags"]);

    const handleTagDropdownClick = async ({ key: tagId }) => {
      // Mejora de performance: Enviar los datos de la tag en el payload, luego ejecutar el commit antes de la petición.

      const payload = {
        ticketsId: [...selectedTableRowKeys.value],
        tagId,
      };

      // try {
      await store.dispatch("tagTickets", payload);
      handleUpdateData();
      //   message.success("Se han etiquetado los tickets correctamente");
      // } catch (error) {
      //   console.error(error);
      //   message.error("No se pudo etiquetar " + error?.getErrorMessage?.() || "");
      // }
    };

    const handleResolve = () => {
      const channelTypeCounter = { voice: 0, chat: 0 };

      if (selectedTableRowKeys.value.length == selectedRowsLastChannel.value.length) {
        selectedRowsLastChannel.value.forEach((channel) => {
          const icon = channel?.icon?.toLowerCase();
          const isChat = icon?.includes("whatsapp") || icon?.includes("chat") || icon?.includes("messenger") || icon?.includes("sms");
          const isVoice = icon?.includes("voice");

          if (isChat) channelTypeCounter.chat++;
          if (isVoice) channelTypeCounter.voice++;
        });
      }
      
      const hasVoiceText = channelTypeCounter.voice !== 0;
      const hasChatText = channelTypeCounter.chat !== 0;

      const voiceText =
        channelTypeCounter.voice === 1
          ? "1 ticket de llamada"
          : `${channelTypeCounter.voice} tickets de llamadas`;
      const chatText =
        channelTypeCounter.chat === 1
          ? "1 ticket de chat"
          : `${channelTypeCounter.chat} tickets de chats`;

      const modalChannelNumbers = hasVoiceText || hasChatText ? `Estás por resolver ${hasVoiceText ? voiceText : ""}${
        hasVoiceText && hasChatText ? " y " : ""
      }${hasChatText ? chatText : ""}. ` : '';

      const ticketsNumber = selectedTableRowKeys.value.length;

      const modalTitleTickets =
        ticketsNumber === 1
          ? "el ticket seleccionado"
          : `${ticketsNumber} tickets seleccionados`;

      Modal.confirm({
        title: `Estás a punto de resolver ${modalTitleTickets}. ¿Deseas continuar?`,
        content: `${modalChannelNumbers}Recuerda que ${
          ticketsNumber === 1 ? "desaparecerá" : "desaparecerán"
        } del workspace del usuario y ${
          ticketsNumber === 1
            ? "si no cuenta con tipificación se le"
            : "aquellas que no cuenten con tipificación se les"
        } asignará una por defecto.`,
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        onOk: async () => {
          try {
            await store.dispatch("resolveTickets", [...selectedTableRowKeys.value]);
            message.success("Se han resuelto los tickets correctamente");
            updateSelectedTableRowKeys([]);
            handleUpdateData();
          } catch (error) {
            console.log(error);
            message.error("Ocurrió un error");
          }
        },
        okText: "Resolver",
        cancelText: "Cancelar",
      });
    };

    const handleUpdateData = () => {
      emit("update-data");
    };

    const handleOpenAdvancedFiltersDrawer = () => {
      emit("open-advanced-filters-drawer");
    };

    const handleOpenColumnFilterDrawer = () => {
      emit("open-column-filter-drawer");
    };

    const handleDownload = () => {
      emit("file-download");
    };

    const basicFilters = computed(() => store.getters["getTicketsBasicFilters"]);
    const tablePage = computed(() => store.getters["getTablePage"]);
    const advancedFilters = computed(() => store.getters["getTicketsAdvancedFilters"]);

    const handleSelectedAll = async () => {
      // loadingTable.value = true;

      const filters = { ...basicFilters.value, page: tablePage.value };
      let ids = [];
      // console.log(advancedFilters.value, 'advancedFilters.value')
      if (!advancedFilters.value) {
        selectedTableRowKeys.value = await fetchTicketsIdsWithBasicFilters(filters);
        console.log(selectedTableRowKeys.value, "ids tickets all");
      } else {
        selectedTableRowKeys.value = await fetchTicketsIdsWithAdvancedFilters({
          ...basicFilters.value,
          ...advancedFilters.value,
        });
      }

      // loadingTable.value = false;
    };

    const changeEntity = (entity) => {
      if (advancedFilters.value?.queues?.length > 0 || advancedFilters.value?.users?.length > 0) {
        Modal.confirm({
          icon: createVNode(QuestionCircleOutlined),
          title: "¿Estás seguro de cambiar de empresa?",
          content: "Recuerda que el filtro de colas y usuarios se reiniciará.",
          okText: "Cambiar",
          cancelText: "Cancelar",
          centered: true,
          onOk: async () => {
            formState.entity = entity;
            formState.portfolio = "";
            changeTableControls(true);
          },
        });
      } else {
        formState.entity = entity;
        formState.portfolio = "";
        changeTableControls(true);
      }
    };

    const changePortfolio = (portfolio) => {
      if (advancedFilters.value?.queues?.length > 0 || advancedFilters.value?.users?.length > 0) {
        Modal.confirm({
          icon: createVNode(QuestionCircleOutlined),
          title: "¿Estás seguro de cambiar de campaña?",
          content: "Recuerda que el filtro de colas y usuarios se reiniciará.",
          okText: "Cambiar",
          cancelText: "Cancelar",
          centered: true,
          onOk: async () => {
            formState.portfolio = portfolio;
            changeTableControls(true);
          },
        });
      } else {
        formState.portfolio = portfolio;
        changeTableControls(true);
      }
    };

    const changeDateRange = (dateRange) => {
      if (advancedFilters.value?.queues?.length > 0 || advancedFilters.value?.users?.length > 0) {
        Modal.confirm({
          icon: createVNode(QuestionCircleOutlined),
          title: "¿Estás seguro de cambiar de intervalo de fechas?",
          content: "Recuerda que el filtro de colas y usuarios se reiniciará.",
          okText: "Cambiar",
          cancelText: "Cancelar",
          centered: true,
          onOk: async () => {
            formState.dateRange = dateRange;
            changeTableControls(true);
          },
        });
      } else {
        console.log("cambio de rango de fechas 0", formState.dateRange);
        console.log("cambio de rango de fechas - changed", dateRange);
        formState.dateRange = dateRange;
        console.log("cambio de rango de fechas 2", formState.dateRange);
        changeTableControls(true);
      }
    };

    return {
      channelOptions,
      blockAllEntities,
      // disabledDownload,
      wrongInputsMessage,
      isGlobalDownloading,
      formRef,
      formState,
      tagsData,
      handleTagDropdownClick,
      handleResolve,
      handleUpdateData,
      handleOpenAdvancedFiltersDrawer,
      handleOpenColumnFilterDrawer,
      handleDownload,
      disabledDateFuture,
      selectedRowsList,
      openQueueTransferModal,
      openUserTransferModal,
      openQueueUserTransferModal,
      uniquePortfolios,
      uniqueQueues,
      transferData,
      handleTransferClick,
      handleDropdownClick,
      updateSelectedTableRowKeys,
      selectedAll,
      selectedAllDataFilters,
      handleSelectedAll,
      changeEntity,
      changePortfolio,
      changeDateRange,
      advancedFilters,
      portfolioItemsSelectedTransfer,
      rangeLimitText,
      plan,
      PlanEspecial,
    };
  },
};
</script>

<style lang="sass" scoped>
.table-controls-margin
  margin-bottom: 5px

.selected-rows-buttons__wrapper
  display: flex
  flex-direction: column
  align-items: flex-end
  position: relative

.refresh-wrapper, .selected-rows-counter
  position: absolute
  bottom: 32px
  margin-bottom: 4px
  font-size: 16px

.refresh-wrapper
  right: 0
  bottom: 28px

.tag-dropdown-menu
  display: flex
  align-items: center

.tag-color
  width: 8px
  height: 8px
  border-radius: 50%
  margin-right: 8px

section
  display: grid
  justify-items: center
  color: $gray-6
  font-size: 20px
  margin: auto 0

.multiselect-row
  text-align: center

  .counter
    color: $gray-8
    background-color: $geekblue-4
    padding: 4px 0

  .actions
    background-color: $geekblue-1
    padding: 3px 0

  .divider
    background-color: $text-secondary
    height: 1.5em
</style>

<style>
.table-controls-margin .ant-form-item {
  margin-right: 8px !important;
}
</style>
